export default __webpack_public_path__ + "static/media/portfolio.83fba234.png";